import { render, staticRenderFns } from "./BCRadioSettings.vue?vue&type=template&id=14485d60&scoped=true"
import script from "./BCRadioSettings.vue?vue&type=script&lang=js"
export * from "./BCRadioSettings.vue?vue&type=script&lang=js"
import style0 from "./BCRadioSettings.vue?vue&type=style&index=0&id=14485d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14485d60",
  null
  
)

export default component.exports